import { axiosSakusas } from "../axios/sakusas_axios";

export type PanelAddParams = {
  datum: Date;
  title: string;
  fileName: string;
};

export type PanelSearchParams = {
  skip?: number;
  limit?: number;
};

export const panelAdd = async ({
  datum,
  title,
  fileName,
}: PanelAddParams): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosSakusas.post("panel", { datum, title, fileName });
  } catch (error) {}
  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

const panelResponseFormat = (panel: any): any => {
  const result = { ...panel, datum: new Date(panel.datum) };

  return result;
};

export const panelGet = async (
  id: string,
  searchBy: string = "id"
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosSakusas.get(`panel/${id}?searchBy=${searchBy}`);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result = panelResponseFormat(result);
  }

  return result;
};

export const panelSearch = async (
  searchParams?: PanelSearchParams
): Promise<any> => {
  let result: any = null;
  let response: any;
  try {
    response = await axiosSakusas.post(`panel/search`, searchParams ?? {});
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
    result.items = result.items.map((item: any) => panelResponseFormat(item));
  }

  return result;
};

export const panelUpdate = async (
  id: string,
  updatePayload: any
): Promise<string> => {
  let result: string = "";
  let response: any;
  try {
    response = await axiosSakusas.put(`panel/${id}`, updatePayload);
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const panelDelete = async (id: string): Promise<boolean> => {
  let result: boolean = false;
  let response: any;
  try {
    response = await axiosSakusas.delete(`panel/${id}`);
    result = true;
  } catch (error) {}
  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};
